import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import Debug from 'debug';

import shallowCompare from '../../lib/shallowCompare';

import styles from './index.sass';

const debug = Debug('delectable');

class Popover extends React.Component {
  static propTypes = {
    children      : React.PropTypes.element.isRequired,
    body          : React.PropTypes.node.isRequired,
    isOpen        : React.PropTypes.bool,
    onBodyClick   : React.PropTypes.func,
    style         : React.PropTypes.object,
    bodyStyle     : React.PropTypes.object,
    position      : React.PropTypes.string,
    activation    : React.PropTypes.string,
    className     : React.PropTypes.string,
    bodyClassName : React.PropTypes.string
  };

  static defaultProps = {
    style         : {},
    bodyStyle     : {},
    position      : 'left',
    activation    : 'click' // or 'hover'
  };

  constructor(props) {
    super(props);
    this.handleClickBody = this.handleClickBody.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevProps.isOpen && this.props.isOpen && this.props.activation === 'click') {
      this.targetEl = ReactDOM.findDOMNode(this.refs.popover);
      window.addEventListener('mousedown', this.handleClickBody);
      window.addEventListener('touchstart', this.handleClickBody);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.props.isOpen && !nextProps.isOpen) {
      window.removeEventListener('mousedown', this.handleClickBody);
      window.removeEventListener('touchstart', this.handleClickBody);
    }
  }

  handleClickBody(e) {
    if(!this.targetEl.contains(e.target) && this.props.activation === 'click') {
      if(e.target.classList.length && e.target.classList[0].indexOf(styles.popover) !== -1) {
        this.props.onBodyClick();
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      this.props.onBodyClick();
    }
  }

  render() {
    let bodyStyle = _.extend({display: this.props.isOpen ? 'block' : 'none'}, this.props.bodyStyle);
    let bodyClasses = styles.popoverBody;
    let classes = styles.popover;

    if(this.props.position === 'right') {
      bodyClasses += (' ' + styles.popoverBodyRight);
    } else {
      bodyClasses += (' ' + styles.popoverBodyLeft);
    }

    if(this.props.bodyClassName) {
      bodyClasses += (' ' + this.props.bodyClassName);
    }

    if(this.props.className) {
      classes += (' ' + this.props.className);
    }
    return (
      <div className={classes} style={this.props.style} ref="popover">
        {this.props.children}
        <div className={bodyClasses} style={bodyStyle} ref="popoverBody">
          {this.props.body}
        </div>
      </div>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// client/components/Popover/index.js